import React, {useMemo} from 'react'
import {initial} from "lodash";

type props = {
  title?: string
  supplierInfo?: any
}

const tagTextMap: any = {
  0: {
    text: '',
    img: '',
    color: '',
    backgroundColor: ''
  },
  1: {
    text: '资料审核中',
    img: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shijian-status.png',
    color: '#1473FF',
    backgroundColor: '#E6F4FF'
  },
  2: {
    text: '审核驳回：',
    img: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/unsubmit.png',
    color: '#F93822',
    backgroundColor: '#FEEBE8'
  },
  3: {
    text: '资料审核通过',
    img: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/done-status.png',
    color: '#02BC98',
    backgroundColor: '#EAF8F0'
  },
  4: {
    text: '',
    img: '',
    color: ''
  },
  5: {
    text: '已签约',
    img: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/done-status.png',
    color: '#02BC98',
    backgroundColor: '#EAF8F0'
  },
}

const SPBreadcrumb: React.FC<props> = (props) => {
  const { supplierInfo } = props
  const style: React.CSSProperties = {
    height: '55px',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '55px',
    paddingLeft: '16px',
    margin: '-20px -20px 0 -20px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    display: 'flex',
    alignItems: 'center',
  }

  const curTagObj = useMemo(() => {
    const obj = tagTextMap[supplierInfo?.entering_status] || {}
    return obj
  }, [supplierInfo?.entering_status])



  const tagStyle: React.CSSProperties = useMemo(() => {
    return {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '22px',
      display: 'flex',
      color: curTagObj.color || 'inherit',
      padding: '4px 8px',
      borderRadius: '6px',
      background: curTagObj.backgroundColor,
      alignItems: 'center',
      height: '30px',
      boxSizing: 'border-box',
      marginLeft: '16px'
    }
  }, [curTagObj])

  return <div style={style}>
    {props?.title}
    {
      curTagObj?.text &&
        <div style={tagStyle}>
            <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={curTagObj.img} alt=""/>
            <div>
              {curTagObj?.text} { supplierInfo?.entering_status === 2 ? supplierInfo?.enter_reject_reason : '' }
            </div>
        </div>
    }
  </div>
}

export default SPBreadcrumb;
